import React, { useState, useEffect } from "react";
import {
  Table,
  Card,
  Button,
  Row,
  Col,
  ListGroup,
  Spinner,
} from "react-bootstrap";
import { Paginate } from "../components/Paginate";
import { filterByField } from "../channels/services/api";
import { useParams, useNavigate } from "react-router-dom";
import { format } from "date-fns";

export default function Subscriptions() {
  const params = useParams();
  const navigate = useNavigate();

  const [subscriptions, setSubscriptions] = useState([]);
  const [channel, setChannel] = useState({});
  const [countedCode, setCountedCode] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState({ pageNumber: 1, data: [] });
  const itemsPerPage = 10;

  async function loadChannel() {
    const filteredChannels = await filterByField(
      "channels",
      "channelId",
      params.channelId
    );

    setChannel(filteredChannels.data[0]);
  }

  async function loadRegister() {
    const filteredRegisters = await filterByField("registers");

    return filteredRegisters.data;
  }

  async function loadSubscriptions() {
    if (params.registerId) {
      const filteredSubscriptions = await filterByField(
        "subscriptions",
        "registerId",
        params.registerId
      );

      return filteredSubscriptions.data;
    } else {
      const filteredSubscriptions = await filterByField(
        "subscriptions",
        "channelId",
        params.channelId
      );

      return filteredSubscriptions.data;
    }
  }

  async function loadData() {
    setIsLoading(true);
    const listSubscriptions = await loadSubscriptions();
    const listRegisters = await loadRegister();

    const subscriptionsWithRegister = listSubscriptions.map((item) => {
      return {
        ...item,
        register: listRegisters.find(
          (reg) => reg.registerId === item.registerId
        ),
      };
    });

    const sortedItems = subscriptionsWithRegister.map((element) => {
      return element;
    });

    sortedItems.sort((a, b) => {
      if (a.created_at > b.created_at) {
        return -1;
      }
      if (a.create_at < b.create_at) {
        return 1;
      }

      return 0;
    });

    setSubscriptions(sortedItems);
    setIsLoading(false);
  }

  async function loadDashboardData() {
    const listSubscriptions = await loadSubscriptions();

    const existsCodes = [];
    listSubscriptions.forEach((subscription) => {
      if (!existsCodes.includes(subscription.code)) {
        existsCodes.push(subscription.code);
      }
    });

    const allCodes = listSubscriptions.map((subscription) => {
      return subscription.code;
    });

    let codeCount = [];
    existsCodes.forEach((code) => {
      const count = allCodes.filter((element) => element === code);
      const obj = {
        key: [count[0]],
        value: count.length,
      };
      codeCount.push(obj);
    });
    setCountedCode(codeCount);
  }
  useEffect(() => {
    loadData();
    loadDashboardData();
    loadChannel();
  }, []);

  return (
    <>
      <Button
        onClick={() => navigate(-1)}
        className="mt-4 d-flex"
        variant="secondary"
      >
        Back
      </Button>

      <Row className="container mt-3">
        <Col className="row row-cols-auto grid gap-3">
          {countedCode.map((item, key) => (
            <React.Fragment key={key}>
              <Card className="dashboard-card">
                <Card.Header className="card-title">{item.key}</Card.Header>
                <Card.Body>
                  <Card.Title className="card-value">{item.value}</Card.Title>
                  <ListGroup className="list-group-flush">
                    <ListGroup.Item>
                      Subscription per Motivation Code
                    </ListGroup.Item>
                  </ListGroup>
                  <Card.Text className="card-description">{}</Card.Text>
                </Card.Body>
              </Card>
            </React.Fragment>
          ))}
        </Col>
      </Row>

      <Card className="mt-4 text-center">
        <Card.Body>
          <Card.Title>
            <Paginate
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              items={subscriptions}
              pagedDataUpdated={(newData) => {
                setCurrentPage(newData);
              }}
            />
            Subscription from <span className="fw-bold">{channel.name}</span>
          </Card.Title>
          {isLoading ? (
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          ) : (
            <Table bordered hover>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Consent</th>
                  <th>Newsletter</th>
                  <th>Motivation Code</th>
                  <th>Date</th>
                </tr>
              </thead>
              {currentPage.data.map((item, subscriptionId) => (
                <React.Fragment key={item.subscriptionId}>
                  <tbody>
                    <tr>
                      <td>{item.register.name}</td>
                      <td>{item.register.email}</td>
                      <td>{item.consent}</td>
                      <td>{item.newsletter}</td>
                      <td>{item.code}</td>
                      <td>
                        {format(new Date(item.created_at), "HH:mm - d/M/Y")}
                      </td>
                    </tr>
                  </tbody>
                </React.Fragment>
              ))}
            </Table>
          )}
        </Card.Body>
      </Card>
    </>
  );
}
